<template>
    <a-modal v-model:visible="visible" title="重置密码" @ok="handleCommit" :okText="'确定修改'" :cancelText="'取消'">
        <a-alert
            v-if="loading.visible"
            message="两次密码不一致"
            type="warning"
        />
        <div class="forget">
            <a-space direction="vertical" style="width: 100%" size="middle">
                <a-input v-model:value="phone" placeholder="输入手机号码"/>
                <div>
                    <a-input v-model:value="verCode" placeholder="输入验证码" style="width: 360px;margin-right: 10px"/>
                    <a-button type="primary" @click="sendCode" class="code-button" :loading="loading.codeLoading">{{ loading.codeText }}</a-button>
                </div>
                <a-input-password v-model:value="password" placeholder="输入新的密码">
                    <template #prefix><LockOutlined style="color: rgba(0, 0, 0, 0.25)" /></template>
                </a-input-password>
                <a-input-password v-model:value="rePassword" placeholder="再次输入密码" v-on:blur="checkPwd">
                    <template #prefix><LockOutlined style="color: rgba(0, 0, 0, 0.25)" /></template>
                </a-input-password>
            </a-space>
        </div>
    </a-modal>
</template>

<script>
import {onMounted, reactive, ref} from "@vue/runtime-dom"
import { LockOutlined } from '@ant-design/icons-vue'
import {notification} from "ant-design-vue";
import {sendPhoneCode, forgetPasswordApi} from "@/api/directories"
export default {
    name: "ForgetPWD",
    props: {
        visible: Boolean
    },
    setup() {
        const password = ref('')
        const rePassword = ref('')
        const phone = ref('')
        const verCode = ref('')
        const pageStyle = reactive({
            style: {}
        })
        const loading = reactive({
            codeLoading: false,
            codeText: '发送验证码',
            isCode: false,
            visible: false
        })
        onMounted(() => {
            pageStyle.style = { height: window.innerHeight+'px', width: window.innerWidth + 'px'}
        })
        return {
            password,
            pageStyle,
            loading,
            phone,
            rePassword,
            verCode
        }
    },
    methods: {
        checkPhone(phone) {
            if(!(/^1[3456789]\d{9}$/.test(phone))){
                return false
            } else {
                return true
            }
        },
        sendCode() {
            const mobileCheck = this.checkPhone(this.phone)
            if (!mobileCheck) {
                notification.error({ message: '手机号格式不正确，请重新输入！', duration: 1.5, description: '' })
                return
            } else {
                let timeClock
                sendPhoneCode(this.phone).then((res) => {
                    if (res == '发送成功') {
                        this.loading.codeLoading = true
                        this.loading.isCode = true
                        let time = 60
                        timeClock = setInterval(() => {
                            time --
                            this.loading.codeText = time+'秒后重试'
                            if (time == 0) {
                                clearInterval(timeClock)
                                this.loading.codeLoading = false
                                this.loading.codeText = '发送验证码'
                            }
                        }, 1000)
                    }
                })
            }
        },
        checkPwd() {
            if(this.password) {
                if (this.password != this.rePassword) {
                    this.loading.visible = true
                    setTimeout(() => {
                        this.loading.visible = false
                    }, 3000)
                }
            }
        },
        async handleCommit() {
            const mobileCheck = this.checkPhone(this.phone)
            if (!mobileCheck) {
                notification.warning({ message: '手机号格式不正确，请重新输入！', duration: 1.5, description: '' })
                return
            }
            if (this.verCode == '') {
                notification.warning({ message: '请输入验证码！', duration: 1.5, description: '' })
                return
            }
            const params = {
                contactsPhone: this.phone,
                verCode: this.verCode,
                workDescribe: this.rePassword
            }
            const res = await forgetPasswordApi(params)
            if (res) {
                notification.success({ message: '重置成功！', duration: 2, description: '' })
                this.$emit('reset')
            }
        },
    },
    components: {
        LockOutlined
    }
}
</script>

<style scoped lang="stylus">
    .forget >>> .ant-input {
        //margin 10px 0
    }
    .forget >>> .ant-input-affix-wrapper {
        position: relative;
        width: 100%;
        padding: 4px 11px;
        color: rgba(0, 0, 0, 0.85);
        font-size: 14px;
        line-height: 1.5715;
        background-color: #fff;
        background-image: none;
        border: 1px solid #d9d9d9;
        border-radius: 2px;
        transition: all 0.3s;
        display: inline-flex;
    }
</style>